import { jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { Popover } from "@nxt-costco-com/forge-components";
import { FindAWarehouseForm } from "../../../Forms/FindAWarehouseForm/index.js";
function TextOnly({ entry }) {
  if (!entry) return null;
  return /* @__PURE__ */ jsx("div", { "data-testid": "findawarehouse-popover", children: /* @__PURE__ */ jsx(
    Popover,
    {
      buttonText: entry.active_state.active_state_link.title,
      hasArrow: false,
      position: "bottom-start",
      roleRegion: true,
      setFocus: "First Actionable",
      triggerAction: "onClick",
      children: /* @__PURE__ */ jsx(Suspense, { children: /* @__PURE__ */ jsx(
        FindAWarehouseForm,
        {
          locale: entry.locale,
          variant: "standard"
        }
      ) })
    }
  ) });
}
export {
  TextOnly
};
